import { TKeys } from '../../core/constants/TKeys';
import { ToasterMessageType } from '../../core/enums/ToasterMessageType';
import { ERROR_TYPES } from '../../core/enums/ERROR_TYPES';

/**
 * @name ToastMessages
 * @type {Object<ERROR_TYPES, string>}
 */
export const ToastMessages = {
  [ERROR_TYPES.INVALID_TOKEN]: TKeys.InvalidToken,
  [ERROR_TYPES.INVALID_SPIN]: TKeys.BetCanceled,
  [ERROR_TYPES.MONEY_TRANSACTION_ERROR]: TKeys.BetCanceled,
  [ERROR_TYPES.NOT_ENOUGH_MONEY]: TKeys.NotEnoughBalance,
  [ERROR_TYPES.INVALID_OPERATION]: TKeys.BetCanceled,
  [ERROR_TYPES.SPIN_NOTFOUND]: TKeys.BetCanceled,
  [ERROR_TYPES.INVALID_SPIN_COUNT]: TKeys.BetCanceled,
  [ERROR_TYPES.INVALID_AMOUNT]: TKeys.InvalidAmount,
  [ERROR_TYPES.BUY_BONUS_DISABLED]: TKeys.BuyBonusDisabled,
  [ERROR_TYPES.PlayerLimitExceeded]: TKeys.LimitExceeded,
  _: TKeys.UnHandledError,
};

/**
 * @name ToastType
 * @type {Object<ERROR_TYPES, ToasterMessageType>}
 */
export const ToastTypes = {
  [ERROR_TYPES.INVALID_TOKEN]: ToasterMessageType.Error,
  [ERROR_TYPES.INVALID_SPIN]: ToasterMessageType.Error,
  [ERROR_TYPES.MONEY_TRANSACTION_ERROR]: ToasterMessageType.Error,
  [ERROR_TYPES.NOT_ENOUGH_MONEY]: ToasterMessageType.Error,
  [ERROR_TYPES.INVALID_OPERATION]: ToasterMessageType.Error,
  [ERROR_TYPES.SPIN_NOTFOUND]: ToasterMessageType.Error,
  [ERROR_TYPES.INVALID_SPIN_COUNT]: ToasterMessageType.Error,
  [ERROR_TYPES.INVALID_AMOUNT]: ToasterMessageType.Error,
  [ERROR_TYPES.BUY_BONUS_DISABLED]: ToasterMessageType.Error,
  [ERROR_TYPES.PARTNER_NOT_FOUND]: ToasterMessageType.Error,
  [ERROR_TYPES.PlayerLimitExceeded]: ToasterMessageType.Error,
  _: ToasterMessageType.Warning,
}